<div class="sidenav">
  <div class="login-main-text">
    <img src='/assets/{{ this.getLogo() }}' alt='logo' class='logo' />
    <!-- <h2>Waste System</h2> -->
    <p>Login from here to access.</p>
  </div>
</div>
<div class="main">
  <div class="col-md-6 col-sm-12">
    <div class="login-form">
      @if (this.isLoginError) {
        <div class="alert alert-danger" role="alert">
          Login failed using the provided email and password
        </div>
      }
      <form>
        <div class="form-group">
          <input type="text" name='email' class="form-control" [(ngModel)]='this.email' placeholder="Email" [class.is-invalid]='this.hasError("email")'>
        </div>
        <div class="form-group">
          <input type="password" name='password' class="form-control" [(ngModel)]='this.password' (keyup.enter)="onLoginButtonClicked()" placeholder="Password" [class.is-invalid]='this.hasError("password")'>
        </div>
        <button type="button" class="btn btn-secondary" (click)='this.onLoginButtonClicked()'>Login</button>
        <button type="submit" class="btn btn-secondary" style='display:none;'>Register</button>
      </form>
      <div class='loginDivider'>or</div>
      <button type="button" class="btn btn-secondary" (click)='this.onMicrosoftLoginButtonClicked()'>
        <i class="fab fa-microsoft"></i> Sign in with Microsoft
      </button>
    </div>
  </div>
</div>
